import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import Accordion from '@mui/material/Accordion';
import { Button, TextField, Card, Grid, CardHeader, CardContent, Typography, Box } from '@mui/material';
import { SelectField } from 'components';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { enqueueSnackbar } from 'actions';
import { SetFormState, ToggleOptionsFailuresTrackerForm, AddDropdownField, RemoveDropdownField } from '../../actions/FailuresActions';

const FailuresTrackerOptionsForm = (props) => {
	const { open, dropdownLabel, dropdownName, dropdownValue, dropdownId, ...rest } = props;
	const dispatch = useDispatch();
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector(state => state.failuresReducer.formState);

	const [dropdownValueAdded, setdropdownValueAdded] = useState('');

	const _handleChange = (event) => {
		setdropdownValueAdded(event.target.value);
	};

	const _handleClose = () => {
		dispatch(ToggleOptionsFailuresTrackerForm(false));
	};

	const relations = { cfn1LevelId: formState.values.cfn1LevelVoice, cfn2LevelId: formState.values.cfn2LevelVoice, cfn3LevelId: formState.values.cfn3LevelVoice };

	const _handleAdd = () => {
		dispatch(AddDropdownField(userId, dropdownName, dropdownValueAdded, relations));
		dispatch(ToggleOptionsFailuresTrackerForm(false));
	};

	const _handleRemove = () => {
		dispatch(RemoveDropdownField(userId, dropdownName, dropdownValue, dropdownId, relations));
		dispatch(ToggleOptionsFailuresTrackerForm(false));
		setFormState({
			...formState,
			values: {
				...formState.values,
				[dropdownName]: undefined
			}
		});
	};

	const [expanded, setExpanded] = useState(false);

	return (
		<div>
			<Dialog open={open} onClose={_handleClose}>
				<DialogTitle>{dropdownLabel}</DialogTitle>
				<DialogContent>
					<Box
						component="form"
						sx={{
							'& > :not(style)': { m: 1, width: '25ch' },
						}}
						noValidate
						autoComplete="off"
					>
						<Grid hidden={dropdownId !== undefined}>
							<TextField
								id="outlined-basic"
								name={dropdownLabel}
								label={dropdownLabel}
								variant="outlined"
								onChange={_handleChange}
							/>
						</Grid>
						<Grid hidden={dropdownId === undefined}>
							<Typography variant="h6">
								{`Are you sure you want to delete [${dropdownLabel}] - ${dropdownValue}?`}
							</Typography>
						</Grid>
					</Box>
				</DialogContent>
				<DialogActions>
					<Grid hidden={dropdownId !== undefined}>
						<Button onClick={_handleClose}>Close</Button>
						<Button onClick={_handleAdd}>Add</Button>
					</Grid>
					<Grid hidden={dropdownId === undefined}>
						<Button onClick={_handleClose}>Cancel</Button>
						<Button onClick={_handleRemove}>Remove</Button>
					</Grid>
				</DialogActions>
			</Dialog>
		</div>
	);
};

FailuresTrackerOptionsForm.propTypes = {
	open: PropTypes.bool,
	dropdownLabel: PropTypes.string.isRequired,
	dropdownName: PropTypes.string.isRequired,
	dropdownValue: PropTypes.string,
	dropdownId: PropTypes.string
};

export default FailuresTrackerOptionsForm;
